import { z } from 'zod';

/** Проверяет комментарий для действия с исполнителем заказа */
export const orderCommentActionSchema = z.object({
    comment: z.string()
        .trim(),
});

export type OrderCommentActionFormValues = z.infer<typeof orderCommentActionSchema>;

export const ORDER_COMMENT_ACTION_DEFAULTS: OrderCommentActionFormValues = {
    comment: '',
};
